import MedicineCabinetCategoryEdit from "@/medicine-cabinet/views/MedicineCabinetCategoryEdit.vue";

const medicineCabinetRouter = [
    {
        path: 'medicine-cabinet/categories/:categoryId',
        name: 'medicine-cabinet.categories.edit',
        component: MedicineCabinetCategoryEdit,
    }
];

export default medicineCabinetRouter;
